// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../statics/modal_image_close.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScreenPersonalBackpack_main__UnDIT {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 40px 0 70px 0;
    cursor: default;
}

.ScreenPersonalBackpack_container__jknvE {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 70%;
    height: 100%;
}

.ScreenPersonalBackpack_container_header__ChfyC {
    display: flex;
    justify-content: center;
    width: 100%;
    height: 50px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 24px;
    color: #101417;
}

.ScreenPersonalBackpack_container_content__ULj1D {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: calc(100% - 100px);
    padding: 0 20px;
}

.ScreenPersonalBackpack_container_content_left__HhJmI {
    /* display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center; */
    width: 45%;
    height: 100%;
    /* border: 1px solid #D9D9D9; */
    border-radius: 12px;
    padding: 35px 40px;
}

.ScreenPersonalBackpack_container_content_right__RB\\+Qf {
    width: 45%;
    height: 100%;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
    padding: 35px;
}

.ScreenPersonalBackpack_container__jknvE {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.ScreenPersonalBackpack_left_level_box__Gk6Vq,
.ScreenPersonalBackpack_model_box__TpP-O {
    width: 100%;
    height: 500px;
}

.ScreenPersonalBackpack_level_middle__YEUS4 {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: calc(100% - 240px);
}

.ScreenPersonalBackpack_level_middle_butn__0qOxA {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100px;
    height: 38px;
    border: 1px solid #E1E1E1;
    border-radius: 6px;
}

.ScreenPersonalBackpack_level_middle_bg_img__O\\+7i1 {
    width: 165px;
    height: 165px;
}

.ScreenPersonalBackpack_dollar_img__syTWW {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 15px;
    color: #323A45;
}

.ScreenPersonalBackpack_level_middle_butn_text__1kDWn {

}

.ScreenPersonalBackpack_left_butn_box__Lmiw9 {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 70px;
    font-family: 'PingFangSCMedium';
    font-size: 16px;
    padding-top: 20px;
}

.ScreenPersonalBackpack_haved_add_box__bpS0H {
    padding-bottom: 26px;
    border-bottom: 1px solid #D9D9D9;
}

.ScreenPersonalBackpack_no_add_box__Qw0WY {
    padding-top: 26px;
}

.ScreenPersonalBackpack_content_title__bue3Z {
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
    margin-bottom: 26px;
}

.ScreenPersonalBackpack_add_model_box__7u3Oy,
.ScreenPersonalBackpack_no_add_model_box__eoNgm {
    /* display: flex;
    flex-wrap: wrap;
    gap: 12px; */
    padding: 8px;
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 10px;
}

.ScreenPersonalBackpack_right_butn_box__s0RhK {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 100%;
    height: 70px;
    font-family: 'PingFangSCMedium';
    font-size: 16px;
    padding-top: 19px;
    border-top: 1px solid #D9D9D9;
}

.ScreenPersonalBackpack_model_item_box__YLsuO {
    /* flex: 1 0 calc(20% - 10px);
    max-width: calc(20% - 10px); */
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    /* width: 60px; */
    /* height: 85px; */
    height: 100px;
}

.ScreenPersonalBackpack_model_item__-gqAp {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
}

.ScreenPersonalBackpack_no_add_model_box__eoNgm .ScreenPersonalBackpack_model_item__-gqAp {
    cursor: pointer;
    transition: background-color 0.5s, border 0.5s;
    -webkit-user-select: none;
            user-select: none;
}

.ScreenPersonalBackpack_no_add_model_box__eoNgm .ScreenPersonalBackpack_model_item__-gqAp:hover {
    border: 1px solid #17A8B5;
    background-color: #e4f0f2;
}

.ScreenPersonalBackpack_no_add_model_box__eoNgm .ScreenPersonalBackpack_model_item__-gqAp:active {
    background-color: #a2cfd6;
}

.ScreenPersonalBackpack_model_item_img__vIHyo {
    width: 45px;
    height: 45px;
}

.ScreenPersonalBackpack_model_item_add_img__5E6eX {
    position: absolute;
    top: -7px;
    right: -7px;
    cursor: pointer;
    z-index: 10;
}

.ScreenPersonalBackpack_model_item_remove__hoanU {
    /* background-color: #f0f0f0; */
}

.ScreenPersonalBackpack_model_item_remove__hoanU .ScreenPersonalBackpack_model_item_grayscale__sUvuo {
    width: 100%;
    height: 100%;
    position: absolute;
    background-color: rgba(240, 240, 240, 0.5);
    border-radius: 6px;
    z-index: 1;
}

.ScreenPersonalBackpack_model_item_name__7FPFq {
    width: 60px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    line-height: 18px;
    color: #323a45;
    text-align: center;
    /* text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden; */
}

.ScreenPersonalBackpack_remove_area_box__CX7b6 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 96%;
    border: 1px solid #c8c8c9;
    border-radius: 12px;
    background-color: #ebebec;
}

.ScreenPersonalBackpack_remove_area_img__Lu9Ko {
    width: 78px;
    height: 78px;
    margin-bottom: 30px;
}

.ScreenPersonalBackpack_remove_area_text__0FIKZ {
    font-family: 'PingFangSCMedium';
    font-size: 16px;
    color: #A6A6A6;
    letter-spacing: 2px;
}

.ScreenPersonalBackpack_level_model_item_box__mhv3z {
    position: relative;
    width: 100%;
    height: 120px;
}

.ScreenPersonalBackpack_level_model_item__ZLKlQ {
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border: 1px solid #d9d9d9;
    border-radius: 6px;
    background-color: #ebebec;
    -webkit-user-select: none;
            user-select: none;
}

.ScreenPersonalBackpack_level_model_item_img_box__k9b9j {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.5s, border 0.5s;
}

.ScreenPersonalBackpack_level_model_item_add__3zsxD {

}

.ScreenPersonalBackpack_level_model_item_add__3zsxD:hover {
    border: 1px solid #17A8B5;
    background-color: #e4f0f2;
}

.ScreenPersonalBackpack_level_model_item_add__3zsxD:active {
    background-color: #a2cfd6;
}

.ScreenPersonalBackpack_level_model_item_available__ImnDU {
    background-color: transparent;
    transition: background-color 0.5s, border 0.5s;
}

.ScreenPersonalBackpack_level_model_item_select__GWHvF {
    border: 1px solid #22A0AC;
}

.ScreenPersonalBackpack_level_model_item_top_1__pLerR {
    left: 0;
    bottom: 0;
}

.ScreenPersonalBackpack_level_model_item_top_2__qg2Is {
    top: calc(50% - 30px);
    left: calc(25% - 15px);
}

.ScreenPersonalBackpack_level_model_item_top_3__buLlc {
    top: 0;
    left: calc(50% - 30px)
}

.ScreenPersonalBackpack_level_model_item_top_4__Imqru {
    top: calc(50% - 30px);
    right: calc(25% - 15px);
}

.ScreenPersonalBackpack_level_model_item_top_5__aiVIM {
    right: 0;
    bottom: 0;
}

.ScreenPersonalBackpack_level_model_item_bottom_6__6N4Mv {
    left: 0;
    top: 0;
}

.ScreenPersonalBackpack_level_model_item_bottom_7__iNjZA {
    top: calc(50% - 30px);
    left: calc(25% - 15px);
}

.ScreenPersonalBackpack_level_model_item_bottom_8__JAeF\\+ {
    bottom: 0;
    left: calc(50% - 30px)
}

.ScreenPersonalBackpack_level_model_item_bottom_9__cyb7s {
    top: calc(50% - 30px);
    right: calc(25% - 15px);
}

.ScreenPersonalBackpack_level_model_item_bottom_10__Xm2Jd {
    right: 0;
    top: 0;
}

.ScreenPersonalBackpack_level_model_item_text__R9iFr {
    font-size: 12px;
    color: #B8B8B8;
    line-height: 14px;
}

.ScreenPersonalBackpack_container_content_right_unselect__rRNKG {
    /* display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center; */
}

.ScreenPersonalBackpack_container_content_right_select__GF3TX {
    position: relative;
    justify-content: flex-start;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ScreenPersonalBackpack_container_content_right_select__GF3TX::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ScreenPersonalBackpack_container_content_right_select__GF3TX::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ScreenPersonalBackpack_container_content_right_select__GF3TX::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ScreenPersonalBackpack_right_header_close_butn__Y0qFE {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 16px;
    height: 16px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / 100% 100%;
    cursor: pointer;
}

.ScreenPersonalBackpack_right_header_img_box__574sj {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 118px;
    height: 118px;
    margin: 0 auto;
    border-radius: 12px;
    border: 1px solid #e6e6e6;
    margin-top: 25px;
}

.ScreenPersonalBackpack_right_header_img__uv2Aa {
    width: 100px;
    height: 100px;
}

.ScreenPersonalBackpack_right_header_text_box__10Y62 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.ScreenPersonalBackpack_right_header_text__ssIG3 {
    color: #101417;
    font-family: "PingFangSCMedium";
    font-size: 18px;
    font-weight: 700;
    margin: 12px;
}

.ScreenPersonalBackpack_introduce_box__gCJal,
.ScreenPersonalBackpack_example_box__Zef5l {
    width: 100%;
    padding: 10px 0;
}

.ScreenPersonalBackpack_introduce_box__gCJal .ScreenPersonalBackpack_attached_components_info_box__Pne\\+e {
    margin: 10px 0;
}

.ScreenPersonalBackpack_attached_components_info_box__Pne\\+e {
    display: flex;
    width: 100%;
    height: 24px;
    margin-bottom: 3px;
}

.ScreenPersonalBackpack_attached_components_icon_box__FRIam {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 100%;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #fff;
    margin-right: 6px;
}

.ScreenPersonalBackpack_attached_components_icon_text__AmtMV {
    color: #4f4f4f;
    font-size: 11px;
    font-weight: bold;
    margin-left: 5px;
}

.ScreenPersonalBackpack_introduce_title__MwdL1,
.ScreenPersonalBackpack_example_title__Y433X {
    padding: 0 0 5px 10px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 16px;
    color: #101417;
}

.ScreenPersonalBackpack_introduce_text__N732r,
.ScreenPersonalBackpack_example_text__zrqMa {
    width: 100%;
    padding: 13px;
    border: 1px solid #D9D9D9;
    background-color: #f9f9f9;
    border-radius: 12px;
    font-size: 12px;
    line-height: 16px;
    color: #414648;
}

.ScreenPersonalBackpack_example_text__zrqMa img {
    max-width: 100%;
}

.ScreenPersonalBackpack_shopping_model_butn__TBocD {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    border-radius: 6px;
    font-size: 11px;
}

.ScreenPersonalBackpack_shopping_model_owned__j6uLa {
    width: 83px;
    min-width: 83px;
    color: #74bdc6;
    background-color: #e4f0f2;
    border: 1px solid #74bdc6;
    border-bottom-width: 2px;
}

.ScreenPersonalBackpack_shopping_model_purchase__z9zkH {
    width: 128px;
    min-width: 128px;
    color: #EABC4E;
    background-color: #FFF;
    border: 1px solid #D9D9D9;
    border-bottom-width: 2px;
}

.ScreenPersonalBackpack_component_container__6tN46 {
    width: 100%;
    height: 100%;
}

.ScreenPersonalBackpack_component_model_box__HNl\\+q {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    /* gap: 10px; */
    row-gap: 35px;
    column-gap: 15px;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ScreenPersonalBackpack/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI;;;0BAGsB;IACtB,UAAU;IACV,YAAY;IACZ,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;;IAEI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;;IAEI;;gBAEY;IACZ,YAAY;IACZ,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,eAAe;IACf,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI;kCAC8B;IAC9B,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,8CAA8C;IAC9C,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;AACf;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB;;uBAEmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,yBAAyB;IACzB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,wCAAwC;AAC5C;;AAEA;;AAEA;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;AAClD;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,OAAO;IACP,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,MAAM;IACN;AACJ;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,OAAO;IACP,MAAM;AACV;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT;AACJ;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI;;;0BAGsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,kFAAoD,UAAU;IAC1D,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,wFAA0D,WAAW;IACjE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gFAAyF;IACzF,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;;IAEI,qBAAqB;IACrB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb,gBAAgB;AACpB","sourcesContent":[".main {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 40px 0 70px 0;\n    cursor: default;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 70%;\n    height: 100%;\n}\n\n.container_header {\n    display: flex;\n    justify-content: center;\n    width: 100%;\n    height: 50px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 24px;\n    color: #101417;\n}\n\n.container_content {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    height: calc(100% - 100px);\n    padding: 0 20px;\n}\n\n.container_content_left {\n    /* display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center; */\n    width: 45%;\n    height: 100%;\n    /* border: 1px solid #D9D9D9; */\n    border-radius: 12px;\n    padding: 35px 40px;\n}\n\n.container_content_right {\n    width: 45%;\n    height: 100%;\n    border: 1px solid #D9D9D9;\n    border-radius: 12px;\n    padding: 35px;\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.left_level_box,\n.model_box {\n    width: 100%;\n    height: 500px;\n}\n\n.level_middle {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    height: calc(100% - 240px);\n}\n\n.level_middle_butn {\n    display: flex;\n    justify-content: space-evenly;\n    align-items: center;\n    width: 100px;\n    height: 38px;\n    border: 1px solid #E1E1E1;\n    border-radius: 6px;\n}\n\n.level_middle_bg_img {\n    width: 165px;\n    height: 165px;\n}\n\n.dollar_img {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 15px;\n    color: #323A45;\n}\n\n.level_middle_butn_text {\n\n}\n\n.left_butn_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 70px;\n    font-family: 'PingFangSCMedium';\n    font-size: 16px;\n    padding-top: 20px;\n}\n\n.haved_add_box {\n    padding-bottom: 26px;\n    border-bottom: 1px solid #D9D9D9;\n}\n\n.no_add_box {\n    padding-top: 26px;\n}\n\n.content_title {\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n    margin-bottom: 26px;\n}\n\n.add_model_box,\n.no_add_model_box {\n    /* display: flex;\n    flex-wrap: wrap;\n    gap: 12px; */\n    padding: 8px;\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 10px;\n}\n\n.right_butn_box {\n    display: flex;\n    justify-content: space-around;\n    align-items: center;\n    width: 100%;\n    height: 70px;\n    font-family: 'PingFangSCMedium';\n    font-size: 16px;\n    padding-top: 19px;\n    border-top: 1px solid #D9D9D9;\n}\n\n.model_item_box {\n    /* flex: 1 0 calc(20% - 10px);\n    max-width: calc(20% - 10px); */\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    /* width: 60px; */\n    /* height: 85px; */\n    height: 100px;\n}\n\n.model_item {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n}\n\n.no_add_model_box .model_item {\n    cursor: pointer;\n    transition: background-color 0.5s, border 0.5s;\n    user-select: none;\n}\n\n.no_add_model_box .model_item:hover {\n    border: 1px solid #17A8B5;\n    background-color: #e4f0f2;\n}\n\n.no_add_model_box .model_item:active {\n    background-color: #a2cfd6;\n}\n\n.model_item_img {\n    width: 45px;\n    height: 45px;\n}\n\n.model_item_add_img {\n    position: absolute;\n    top: -7px;\n    right: -7px;\n    cursor: pointer;\n    z-index: 10;\n}\n\n.model_item_remove {\n    /* background-color: #f0f0f0; */\n}\n\n.model_item_remove .model_item_grayscale {\n    width: 100%;\n    height: 100%;\n    position: absolute;\n    background-color: rgba(240, 240, 240, 0.5);\n    border-radius: 6px;\n    z-index: 1;\n}\n\n.model_item_name {\n    width: 60px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    line-height: 18px;\n    color: #323a45;\n    text-align: center;\n    /* text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden; */\n}\n\n.remove_area_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 96%;\n    border: 1px solid #c8c8c9;\n    border-radius: 12px;\n    background-color: #ebebec;\n}\n\n.remove_area_img {\n    width: 78px;\n    height: 78px;\n    margin-bottom: 30px;\n}\n\n.remove_area_text {\n    font-family: 'PingFangSCMedium';\n    font-size: 16px;\n    color: #A6A6A6;\n    letter-spacing: 2px;\n}\n\n.level_model_item_box {\n    position: relative;\n    width: 100%;\n    height: 120px;\n}\n\n.level_model_item {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    border: 1px solid #d9d9d9;\n    border-radius: 6px;\n    background-color: #ebebec;\n    user-select: none;\n}\n\n.level_model_item_img_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 60px;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background 0.5s, border 0.5s;\n}\n\n.level_model_item_add {\n\n}\n\n.level_model_item_add:hover {\n    border: 1px solid #17A8B5;\n    background-color: #e4f0f2;\n}\n\n.level_model_item_add:active {\n    background-color: #a2cfd6;\n}\n\n.level_model_item_available {\n    background-color: transparent;\n    transition: background-color 0.5s, border 0.5s;\n}\n\n.level_model_item_select {\n    border: 1px solid #22A0AC;\n}\n\n.level_model_item_top_1 {\n    left: 0;\n    bottom: 0;\n}\n\n.level_model_item_top_2 {\n    top: calc(50% - 30px);\n    left: calc(25% - 15px);\n}\n\n.level_model_item_top_3 {\n    top: 0;\n    left: calc(50% - 30px)\n}\n\n.level_model_item_top_4 {\n    top: calc(50% - 30px);\n    right: calc(25% - 15px);\n}\n\n.level_model_item_top_5 {\n    right: 0;\n    bottom: 0;\n}\n\n.level_model_item_bottom_6 {\n    left: 0;\n    top: 0;\n}\n\n.level_model_item_bottom_7 {\n    top: calc(50% - 30px);\n    left: calc(25% - 15px);\n}\n\n.level_model_item_bottom_8 {\n    bottom: 0;\n    left: calc(50% - 30px)\n}\n\n.level_model_item_bottom_9 {\n    top: calc(50% - 30px);\n    right: calc(25% - 15px);\n}\n\n.level_model_item_bottom_10 {\n    right: 0;\n    top: 0;\n}\n\n.level_model_item_text {\n    font-size: 12px;\n    color: #B8B8B8;\n    line-height: 14px;\n}\n\n.container_content_right_unselect {\n    /* display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    align-items: center; */\n}\n\n.container_content_right_select {\n    position: relative;\n    justify-content: flex-start;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.container_content_right_select::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.container_content_right_select::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.container_content_right_select::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.right_header_close_butn {\n    position: absolute;\n    right: 20px;\n    top: 20px;\n    width: 16px;\n    height: 16px;\n    background: url('../../../../statics/modal_image_close.png') no-repeat center / 100% 100%;\n    cursor: pointer;\n}\n\n.right_header_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 118px;\n    height: 118px;\n    margin: 0 auto;\n    border-radius: 12px;\n    border: 1px solid #e6e6e6;\n    margin-top: 25px;\n}\n\n.right_header_img {\n    width: 100px;\n    height: 100px;\n}\n\n.right_header_text_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.right_header_text {\n    color: #101417;\n    font-family: \"PingFangSCMedium\";\n    font-size: 18px;\n    font-weight: 700;\n    margin: 12px;\n}\n\n.introduce_box,\n.example_box {\n    width: 100%;\n    padding: 10px 0;\n}\n\n.introduce_box .attached_components_info_box {\n    margin: 10px 0;\n}\n\n.attached_components_info_box {\n    display: flex;\n    width: 100%;\n    height: 24px;\n    margin-bottom: 3px;\n}\n\n.attached_components_icon_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 60px;\n    height: 100%;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #fff;\n    margin-right: 6px;\n}\n\n.attached_components_icon_text {\n    color: #4f4f4f;\n    font-size: 11px;\n    font-weight: bold;\n    margin-left: 5px;\n}\n\n.introduce_title,\n.example_title {\n    padding: 0 0 5px 10px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 16px;\n    color: #101417;\n}\n\n.introduce_text,\n.example_text {\n    width: 100%;\n    padding: 13px;\n    border: 1px solid #D9D9D9;\n    background-color: #f9f9f9;\n    border-radius: 12px;\n    font-size: 12px;\n    line-height: 16px;\n    color: #414648;\n}\n\n.example_text img {\n    max-width: 100%;\n}\n\n.shopping_model_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 28px;\n    border-radius: 6px;\n    font-size: 11px;\n}\n\n.shopping_model_owned {\n    width: 83px;\n    min-width: 83px;\n    color: #74bdc6;\n    background-color: #e4f0f2;\n    border: 1px solid #74bdc6;\n    border-bottom-width: 2px;\n}\n\n.shopping_model_purchase {\n    width: 128px;\n    min-width: 128px;\n    color: #EABC4E;\n    background-color: #FFF;\n    border: 1px solid #D9D9D9;\n    border-bottom-width: 2px;\n}\n\n.component_container {\n    width: 100%;\n    height: 100%;\n}\n\n.component_model_box {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    /* gap: 10px; */\n    row-gap: 35px;\n    column-gap: 15px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ScreenPersonalBackpack_main__UnDIT`,
	"container": `ScreenPersonalBackpack_container__jknvE`,
	"container_header": `ScreenPersonalBackpack_container_header__ChfyC`,
	"container_content": `ScreenPersonalBackpack_container_content__ULj1D`,
	"container_content_left": `ScreenPersonalBackpack_container_content_left__HhJmI`,
	"container_content_right": `ScreenPersonalBackpack_container_content_right__RB+Qf`,
	"left_level_box": `ScreenPersonalBackpack_left_level_box__Gk6Vq`,
	"model_box": `ScreenPersonalBackpack_model_box__TpP-O`,
	"level_middle": `ScreenPersonalBackpack_level_middle__YEUS4`,
	"level_middle_butn": `ScreenPersonalBackpack_level_middle_butn__0qOxA`,
	"level_middle_bg_img": `ScreenPersonalBackpack_level_middle_bg_img__O+7i1`,
	"dollar_img": `ScreenPersonalBackpack_dollar_img__syTWW`,
	"level_middle_butn_text": `ScreenPersonalBackpack_level_middle_butn_text__1kDWn`,
	"left_butn_box": `ScreenPersonalBackpack_left_butn_box__Lmiw9`,
	"haved_add_box": `ScreenPersonalBackpack_haved_add_box__bpS0H`,
	"no_add_box": `ScreenPersonalBackpack_no_add_box__Qw0WY`,
	"content_title": `ScreenPersonalBackpack_content_title__bue3Z`,
	"add_model_box": `ScreenPersonalBackpack_add_model_box__7u3Oy`,
	"no_add_model_box": `ScreenPersonalBackpack_no_add_model_box__eoNgm`,
	"right_butn_box": `ScreenPersonalBackpack_right_butn_box__s0RhK`,
	"model_item_box": `ScreenPersonalBackpack_model_item_box__YLsuO`,
	"model_item": `ScreenPersonalBackpack_model_item__-gqAp`,
	"model_item_img": `ScreenPersonalBackpack_model_item_img__vIHyo`,
	"model_item_add_img": `ScreenPersonalBackpack_model_item_add_img__5E6eX`,
	"model_item_remove": `ScreenPersonalBackpack_model_item_remove__hoanU`,
	"model_item_grayscale": `ScreenPersonalBackpack_model_item_grayscale__sUvuo`,
	"model_item_name": `ScreenPersonalBackpack_model_item_name__7FPFq`,
	"remove_area_box": `ScreenPersonalBackpack_remove_area_box__CX7b6`,
	"remove_area_img": `ScreenPersonalBackpack_remove_area_img__Lu9Ko`,
	"remove_area_text": `ScreenPersonalBackpack_remove_area_text__0FIKZ`,
	"level_model_item_box": `ScreenPersonalBackpack_level_model_item_box__mhv3z`,
	"level_model_item": `ScreenPersonalBackpack_level_model_item__ZLKlQ`,
	"level_model_item_img_box": `ScreenPersonalBackpack_level_model_item_img_box__k9b9j`,
	"level_model_item_add": `ScreenPersonalBackpack_level_model_item_add__3zsxD`,
	"level_model_item_available": `ScreenPersonalBackpack_level_model_item_available__ImnDU`,
	"level_model_item_select": `ScreenPersonalBackpack_level_model_item_select__GWHvF`,
	"level_model_item_top_1": `ScreenPersonalBackpack_level_model_item_top_1__pLerR`,
	"level_model_item_top_2": `ScreenPersonalBackpack_level_model_item_top_2__qg2Is`,
	"level_model_item_top_3": `ScreenPersonalBackpack_level_model_item_top_3__buLlc`,
	"level_model_item_top_4": `ScreenPersonalBackpack_level_model_item_top_4__Imqru`,
	"level_model_item_top_5": `ScreenPersonalBackpack_level_model_item_top_5__aiVIM`,
	"level_model_item_bottom_6": `ScreenPersonalBackpack_level_model_item_bottom_6__6N4Mv`,
	"level_model_item_bottom_7": `ScreenPersonalBackpack_level_model_item_bottom_7__iNjZA`,
	"level_model_item_bottom_8": `ScreenPersonalBackpack_level_model_item_bottom_8__JAeF+`,
	"level_model_item_bottom_9": `ScreenPersonalBackpack_level_model_item_bottom_9__cyb7s`,
	"level_model_item_bottom_10": `ScreenPersonalBackpack_level_model_item_bottom_10__Xm2Jd`,
	"level_model_item_text": `ScreenPersonalBackpack_level_model_item_text__R9iFr`,
	"container_content_right_unselect": `ScreenPersonalBackpack_container_content_right_unselect__rRNKG`,
	"container_content_right_select": `ScreenPersonalBackpack_container_content_right_select__GF3TX`,
	"right_header_close_butn": `ScreenPersonalBackpack_right_header_close_butn__Y0qFE`,
	"right_header_img_box": `ScreenPersonalBackpack_right_header_img_box__574sj`,
	"right_header_img": `ScreenPersonalBackpack_right_header_img__uv2Aa`,
	"right_header_text_box": `ScreenPersonalBackpack_right_header_text_box__10Y62`,
	"right_header_text": `ScreenPersonalBackpack_right_header_text__ssIG3`,
	"introduce_box": `ScreenPersonalBackpack_introduce_box__gCJal`,
	"example_box": `ScreenPersonalBackpack_example_box__Zef5l`,
	"attached_components_info_box": `ScreenPersonalBackpack_attached_components_info_box__Pne+e`,
	"attached_components_icon_box": `ScreenPersonalBackpack_attached_components_icon_box__FRIam`,
	"attached_components_icon_text": `ScreenPersonalBackpack_attached_components_icon_text__AmtMV`,
	"introduce_title": `ScreenPersonalBackpack_introduce_title__MwdL1`,
	"example_title": `ScreenPersonalBackpack_example_title__Y433X`,
	"introduce_text": `ScreenPersonalBackpack_introduce_text__N732r`,
	"example_text": `ScreenPersonalBackpack_example_text__zrqMa`,
	"shopping_model_butn": `ScreenPersonalBackpack_shopping_model_butn__TBocD`,
	"shopping_model_owned": `ScreenPersonalBackpack_shopping_model_owned__j6uLa`,
	"shopping_model_purchase": `ScreenPersonalBackpack_shopping_model_purchase__z9zkH`,
	"component_container": `ScreenPersonalBackpack_component_container__6tN46`,
	"component_model_box": `ScreenPersonalBackpack_component_model_box__HNl+q`
};
export default ___CSS_LOADER_EXPORT___;
